import { InterfaceFormErrors, InterfacePayload } from "./types";

export function validateInterface(
  interfaceItem: Partial<InterfacePayload>,
): InterfaceFormErrors {
  const errors: InterfaceFormErrors = {};

  if (!interfaceItem.exportador?.toString().trim())
    errors.exportador = "Exportador é obrigatório";

  const index = interfaceItem.index?.toString().trim();
  if (index && !/^\d+$/.test(index)) errors.index = "Informe apenas números";

  return errors;
}
